import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/auth/me')
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.access_token) localStorage.setItem('dc_access_token', data.access_token);
    setUser(data);
    return data;
  };

  // CONEXIÓN B2B: Recibe el invite_slug y los datos curriculares para pasárselos al backend
  const register = async (email, password, name, invite_slug = null, age = null, levels = [], subjects = []) => {
    const { data } = await api.post('/auth/register', { 
      email, 
      password, 
      name, 
      invite_slug,
      age,
      levels,
      subjects
    });
    if (data.access_token) localStorage.setItem('dc_access_token', data.access_token);
    setUser(data);
    return data;
  };

  const verifyEmail = async (code) => {
    const { data } = await api.post('/auth/verify-email', { code });
    await refreshUser();
    return data;
  };

  const forgotPassword = async (email) => {
    const { data } = await api.post('/auth/forgot-password', { email });
    return data;
  };

  const resetPassword = async (token, newPassword) => {
    const { data } = await api.post('/auth/reset-password', { token, new_password: newPassword });
    return data;
  };

  // Para actualizar los datos desde la pestaña "Mi Perfil"
  const updateProfile = async (profileData) => {
    const { data } = await api.put('/auth/profile', profileData);
    await refreshUser();
    return data;
  };

  // Para cambiar la contraseña desde adentro de la app
  const changePassword = async (currentPassword, newPassword) => {
    const { data } = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch { /* ignore */ }
    localStorage.removeItem('dc_access_token');
    setUser(null);
  };

  const updateCredits = (creditsRemaining) => {
    setUser(prev => prev ? { ...prev, credits_remaining: creditsRemaining } : prev);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
      return data;
    } catch {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ 
        user, loading, login, register, verifyEmail, 
        forgotPassword, resetPassword, updateProfile, changePassword,
        logout, updateCredits, refreshUser 
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
